<template>
  <v-list>
    <v-list-item-group
      :value="value"
      mandatory
      color="success"
      @change="$emit('input', $event)"
    >
      <v-list-item
        v-for="dishOrder in dishOrders"
        :key="dishOrder.id"
        :value="dishOrder.order"
      >
        <v-list-item-content>
          <v-list-item-title v-text="dishOrder.name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
  export default {
    props: {
      value: {
        required: false,
        type: Number,
        default: 0,
      },
    },

    computed: {
      dishOrders () {
        return this.$store.getters['catalog/activeDishOrders']
      },
    },
  }
</script>
